import { t } from "@lingui/macro";
import React from "react";

import { Button } from "@whoosh/design-system/src/components/controls/Button/Button";
import { Box, Text } from "@whoosh/design-system/src/components/primitive";

export const ErrorScreen = ({
  onCancelCallback,
}: {
  onCancelCallback: () => void;
}) => {
  return (
    <Box alignItems="center" justifyContent="center" flex={1} p={4}>
      <Text
        accessibilityRole="header"
        variant="mainTitle3"
        maxFontSizeMultiplier={2}
        mb={4}
      >
        {t`Whoops!`}
      </Text>
      <Text maxFontSizeMultiplier={2} mb={3} fontSize={14} lineHeight={20}>
        {t`Something went wrong with the event sign up...`}
      </Text>
      <Button
        onPress={onCancelCallback}
        accessibilityLabel={t`Close and Try again`}
        testID="close-and-try-again-button"
      >{t`Close and Try again`}</Button>
    </Box>
  );
};
